import { Instagram, Facebook, ExternalLink } from "lucide-react";
import { PROFILE } from "../data/content";

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="bg-royal-900 text-white/80 pt-16 pb-8"
    >
      <div className="mx-auto max-w-7xl px-5 md:px-8 grid md:grid-cols-3 gap-10">
        <div>
          <div className="font-serif-display text-2xl text-white">
            Drª Nivalda P. de Jesus
          </div>
          <div className="mt-1 text-xs tracking-widest uppercase text-white/60">
            {PROFILE.crp}
          </div>
          <p className="mt-5 text-sm leading-relaxed text-white/70">
            Psicóloga clínica, Neuropsicóloga e Sexóloga.
            Doutora pela USP. Atendimento ético, humano e baseado em evidências há mais de 26 anos.
          </p>
        </div>

        <div>
          <div className="text-xs tracking-[0.2em] uppercase text-gold-500 font-semibold">
            Consultório
          </div>
          <div className="mt-4 text-sm space-y-1.5 text-white/80">
            <div>{PROFILE.address_line1}</div>
            <div>{PROFILE.address_line2}</div>
            <div className="pt-2">{PROFILE.phone_landline}</div>
            <div>WhatsApp: {PROFILE.whatsapp_display}</div>
            <a
              href={`mailto:${PROFILE.email}`}
              data-testid="footer-email"
              className="underline hover:text-white block pt-1"
            >
              {PROFILE.email}
            </a>
          </div>
        </div>

        <div>
          <div className="text-xs tracking-[0.2em] uppercase text-gold-500 font-semibold">
            Redes & presença
          </div>
          <div className="mt-4 flex flex-col gap-3">
            <a
              href={PROFILE.instagram}
              target="_blank"
              rel="noreferrer"
              data-testid="footer-instagram"
              className="inline-flex items-center gap-2 text-sm hover:text-white"
            >
              <Instagram size={16} /> {PROFILE.instagram_handle}
            </a>
            <a
              href={PROFILE.facebook}
              target="_blank"
              rel="noreferrer"
              data-testid="footer-facebook"
              className="inline-flex items-center gap-2 text-sm hover:text-white"
            >
              <Facebook size={16} /> /dranivalda.dejesus.3
            </a>
            <a
              href={PROFILE.doctoralia}
              target="_blank"
              rel="noreferrer"
              data-testid="footer-doctoralia"
              className="inline-flex items-center gap-2 text-sm hover:text-white"
            >
              <ExternalLink size={16} /> Perfil no Doctoralia
            </a>
          </div>
        </div>
      </div>

      <div className="mt-12 pt-6 border-t border-white/10 mx-auto max-w-7xl px-5 md:px-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-xs text-white/50">
        <div>
          © {new Date().getFullYear()} Profª Drª Nivalda P. de Jesus. Todos os direitos reservados.
        </div>
        <div>Consultório clínico • Santos/SP • {PROFILE.crp}</div>
      </div>
    </footer>
  );
};
